// The focus where Enter does nothing of its own: the page itself (a step change leaves it there),
// or a plain element of the form. The fields submit natively already, the other controls handle
// Enter themselves.
export const isEnterLeftToForm = (
  target: EventTarget | null,
  form: HTMLFormElement,
): boolean => {
  if (target === document.body) {
    return true;
  }

  return (
    target instanceof HTMLElement &&
    form.contains(target) &&
    !target.isContentEditable &&
    !target.closest(
      'input, button, a, textarea, select, [role="combobox"], [role="listbox"], [role="menu"], [role="button"]',
    )
  );
};
